import React from 'react';
import { bool, string } from 'prop-types';
import { Box, Typography } from '@mui/material';

import { ArrowLink, CopyButton, InlineLinks, InputField } from '../../../../../../../../../../components';
import staticText from '../../../../../../../../../../localization/Application/Simulator/simulator';
import { checkmarkIconGray, checkmarkIconGreen } from '../../../../../../../../../../assets/icons';

const CredentialsInfo = ({
  username, password, vehicleIsConnected, isAutoplay,
}) => {
  return (
    <React.Fragment>
      <Box display="flex" alignItems="center">
        {vehicleIsConnected ?
          <img src={checkmarkIconGreen} alt="success" /> :
          <img src={checkmarkIconGray} alt="pending" />
        }
        <Typography variant="body2" sx={{ marginLeft: 1 }}>{vehicleIsConnected ? 'Vehicle connected' : 'Vehicle not yet connected'}</Typography>
      </Box>
      {isAutoplay && (
        <div>
          <Typography variant="h2" mb={2}>{staticText.credentialsDrawerContent.autoplayTitle}</Typography>
          <Typography variant="body2">
            {staticText.credentialsDrawerContent.autoplayText}
          </Typography>
        </div>
      )}
      <Box display="flex" flexDirection="column" gap={2} mt={4}>
        <Typography variant="h2">{staticText.credentialsDrawerContent.title1}</Typography>
        <Typography variant="body2">
          <InlineLinks text={staticText.credentialsDrawerContent.text1} />
        </Typography>
        <ArrowLink
          link={staticText.credentialsDrawerContent.apiReference.link}
          text={staticText.credentialsDrawerContent.apiReference.text}
        />
      </Box>
      <Box display="flex" flexDirection="column" gap={2} mt={4}>
        <Typography variant="h2">{staticText.credentialsDrawerContent.title2}</Typography>
        <Typography variant="body2">
          <InlineLinks text={staticText.credentialsDrawerContent.text2} />
        </Typography>
        <InputField
          label={staticText.credentialsDrawerContent.emailLabel}
          inputValues={username}
          inputName={staticText.credentialsDrawerContent.emailLabel}
          inputReadOnly
          actions={<CopyButton content={username} />}
        />
        <InputField
          label={staticText.credentialsDrawerContent.passwordLabel}
          inputValues={password}
          inputName={staticText.credentialsDrawerContent.passwordLabel}
          inputReadOnly
          actions={<CopyButton content={password} />}
        />
        <Typography variant="caption">{staticText.credentialsDrawerContent.footnote}</Typography>
      </Box>
    </React.Fragment>
  );
};

export default CredentialsInfo;

CredentialsInfo.propTypes = {
  username: string.isRequired,
  password: string.isRequired,
  vehicleIsConnected: bool.isRequired,
  isAutoplay: bool.isRequired,
};
